import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getToken, isUserAdmin, getUserId } from '../utils/auth';
import { isAdminOnlyPath } from './admin/adminNavigation';
import { USER_HOME_PATH } from '../constants/userRoutes';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const token = getToken();
  const admin = isUserAdmin();
  const userId = getUserId();

  // Sem token, volta ao login preservando o destino (ex.: clique em uma
  // notificação push/arquivo). O Login já entende `?next=`.
  if (!token || !userId) {
    const destino = `${location.pathname}${location.search}`;
    const paraLogin = destino && destino !== '/' ? `/?next=${encodeURIComponent(destino)}` : '/';

    return <Navigate to={paraLogin} state={{ from: location }} replace />;
  }

  // Admin-only routes are centralized in adminNavigation.js (single source).
  if (isAdminOnlyPath(location.pathname) && !admin) {
    return <Navigate to={USER_HOME_PATH} replace />;
  }

  // For user routes, check if user is accessing their own page
  if (location.pathname.startsWith('/user/')) {
    const pathUserId = location.pathname.split('/')[2];

    // Allow access if user is admin or if they're accessing their own page
    if (admin || String(pathUserId) === String(userId)) {
      return children;
    }

    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
